module.exports = new __parcel__URL__("beetlejuice-decoration-bottom-right.fca055b2.svg").toString();